import { RawButton } from '@ps/web-shared-components';
import type { RawButtonProps } from '@ps/web-shared-components';
import React from 'react';

import styles from './PINButton.scss';

const PINButton: React.FC<RawButtonProps> = (props) => (
  <RawButton className={styles.button} variant="secondary" {...props} />
);

export default PINButton;
